import { ReactNode, useMemo } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { RandomOrbGradient } from "src/components/OrbGradient";
import Touchable from "src/components/Touchable";
import useStyle from "src/hooks/useStyle";
import { color } from "src/styles";
import { paddingLarge, paddingMedium, paddingXXL } from "src/styles/spacing";
import { Image, Text } from "src/swsh-native";

const IMAGE_SIZE = 20;
const TEST_ID = "FilterSortCard";
const GatheringFilterSortCard = ({
	text,
	imageSrc,
	hasFallbackImage = false,
	renderSelector,
	onPress,
	bottomBorder,
}: {
	text?: string;
	imageSrc?: string;
	/** If `imageSrc` not provided then fallback on random orb */
	hasFallbackImage?: boolean;
	renderSelector?: () => ReactNode;
	onPress?: () => void;
	bottomBorder?: boolean;
}) => {
	const { theme } = useStyle();

	const content = useMemo(() => {
		return (
			<>
				{imageSrc ? (
					<Image
						alt="Photo for this option"
						src={imageSrc}
						dim={{ width: IMAGE_SIZE, height: IMAGE_SIZE }}
						contentFit="cover"
						style={{ borderRadius: IMAGE_SIZE / 2 }}
					/>
				) : hasFallbackImage ? (
					<RandomOrbGradient size={IMAGE_SIZE} />
				) : null}
				{text && (
					<Text xs semibold style={{ flex: 1 }}>
						{text}
					</Text>
				)}
				{renderSelector?.()}
			</>
		);
	}, [renderSelector, text, imageSrc, hasFallbackImage]);

	const style: StyleProp<ViewStyle> = useMemo(() => {
		return {
			flexDirection: "row",
			width: "100%",
			alignItems: "center",
			paddingHorizontal: paddingXXL,
			paddingVertical: paddingLarge,
			columnGap: paddingMedium,
			backgroundColor: color.BackgroundCard[theme],
			borderBottomWidth: bottomBorder ? 1 : 0,
			borderBottomColor: color.Neutral[theme],
		};
	}, [theme, bottomBorder]);

	return onPress ? (
		<Touchable testID={TEST_ID} style={style} onPress={onPress}>
			{content}
		</Touchable>
	) : (
		<View testID={TEST_ID} style={style}>
			{content}
		</View>
	);
};

export default GatheringFilterSortCard;
